import {
  EnvironmentProviders,
  inject,
  Injectable,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { filter } from 'rxjs/operators';
import { UserProfileService } from '@volo/ngx-lepton-x.core';

@Injectable({ providedIn: 'root' })

// This service filters the user menu to only show the second group of actions in this case Logout only
export class UserMenuFilterService {
  constructor(private userProfileService: UserProfileService) {}

  setupFilter(): void {
    this.userProfileService.user$
      .pipe(filter(user => !!user && Array.isArray(user.userActionGroups)))
      .subscribe(user => {
        const groups = (user!.userActionGroups || []) as any[][];

        if (!groups.length) {
          return;
        }

        const firstGroup = groups[0] || [];
        const secondGroup = groups[1] || [];

        // If first group already empty or no second group, do nothing
        if (!firstGroup.length || !secondGroup.length) {
          return;
        }

        const newGroups: any[][] = [[], secondGroup];

        this.userProfileService.patchUser({
          userActionGroups: newGroups,
        });
      });
  }
}

export function initUserMenuFilter(): void {
  const filterService = inject(UserMenuFilterService);
  filterService.setupFilter();
}

export function provideUserMenuFilter(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      initUserMenuFilter();
    }),
  ]);
}
